import { MyWalletTab } from "./MyWalletTab";
import { NFTItemsFactory } from "../myWalletNFTs/NFTItemsFactory";
import { PackageType, TraitType } from "by/gamefactory/web3/nfts/NFTPackage";
import { IDestroyOptions, Point } from "pixi.js";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { ScrollNextElement } from "../myWalletNFTs/scrollItems/ScrollNextElement";
import { WalletTabType } from "../WalletTabType";
import { NFTScrollItem } from "../myWalletNFTs/scrollItems/NFTScrollItem";
import { IMyWalletController } from "../../controllers/IMyWalletController";
import { Web3Model } from "by/gamefactory/web3/models/Web3Model";
import { FullscreenInputBlocker } from "by/gamefactory/cityversetycoon/scenes/game/components/FullscreenInputBlocker";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { IInventory } from "by/gamefactory/web3/models/IInventory";

export class DiceRollsTab extends MyWalletTab {
    private readonly myWalletResources: MyWalletResourcePackage;
    private readonly web3Model: Web3Model;
    private readonly myWalletController: IMyWalletController;
    private readonly canvasScaler: ICanvasScaler;
    private hadNFT: boolean;

    public constructor(
        myWalletResources: MyWalletResourcePackage,
        nftItemsFactory: NFTItemsFactory,
        inventory: IInventory,
        web3Model: Web3Model,
        myWalletController: IMyWalletController,
        canvasScaler: ICanvasScaler
    ) {
        super(true, WalletTabType.DICE_ROLLS, {
            elementsWidth: 300,
            elementsMargin: 170,
            scrollPosition: new Point(110, 7)
        });
        this.myWalletResources = myWalletResources;
        this.web3Model = web3Model;
        this.myWalletController = myWalletController;
        this.canvasScaler = canvasScaler;
        this.addScrollItems(nftItemsFactory, inventory);
        this.scrollBox.onNFTCollectClick.add(this.onNFTCollectClickHandle, this);
    }

    private addScrollItems(nftItemsFactory: NFTItemsFactory, inventory: IInventory): void {
        const packages = [...inventory.packagesNFT, ...inventory.giftPackagesNFT]
            .filter((value) => value.haveDiceRollsReward && value.packageType != PackageType.DAILY_WHEEL && value.packageType != PackageType.HOURLY_BONUS)
            .sort((firstPkg, secondPkg) => { return secondPkg.diceRollsReward - firstPkg.diceRollsReward });

        for (const nft of packages) {
            const item = nftItemsFactory.createItem(nft);
            if (item == null) {
                continue;
            }
            if (item instanceof Array) {
                item.forEach((nftItem) => this.scrollBox.addItem(nftItem));
            }
            else {
                this.scrollBox.addItem(item);
            }
        }
        if (!inventory.hasBurnableDiceRolls) {
            this.scrollBox.addItem(new ScrollNextElement(this.myWalletResources, WalletTabType.DICE_ROLLS));
            this.scrollBox.position.set(0, 42);
        }
        this.hadNFT = inventory.hasBurnableDiceRolls;
    }

    private async onNFTCollectClickHandle(nftScrollItem: NFTScrollItem): Promise<void> {
        const inputBlocker = new FullscreenInputBlocker(this.canvasScaler);
        inputBlocker.position.set(-162, -750);
        this.addChild(inputBlocker);
        const result = await this.myWalletController.burnNFT(nftScrollItem.data);
        if (result == null) {
            this.removeChild(inputBlocker);
            return;
        }

        if (result.diceRolls > 0) {
            await nftScrollItem.hide();
            this.myWalletController.updateDiceRollsBalance(result.diceRolls);
        }

        if (result.coins > 0) {
            this.myWalletController.updateCoinsBalance(result.coins);
        }

        if (result.shields > 0) {
            this.myWalletController.updateShieldsCount(result.shields);
        }

        await this.scrollBox.removeItem(nftScrollItem);
        if (this.scrollBox.itemsCount === 0) {
            this.scrollBox.addItem(new ScrollNextElement(this.myWalletResources, WalletTabType.DICE_ROLLS));
            this.scrollBox.position.set(0, 42);
            this.hadNFT = false;
            this.updatePointer();
        }
        this.removeChild(inputBlocker);
    }

    public updatePointer(): void {
        this.isHadNFT.emit(this.type, this.hadNFT);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.scrollBox.onNFTCollectClick.remove(this.onNFTCollectClickHandle, this);
        super.destroy(options);
    }
}
